import {
    Box,
    Button,
    Card,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import { useEffect, useState } from "react";
import { getAllState, resetState } from "../../Redux/StateSlice/stateSlice";
import {
    designersReset,
    CreateNewDesigner,
} from "../../Redux/DesignerSlice/DesignerSlice";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { Add, Delete } from "@mui/icons-material";

const CreateDesigner = () => {
    const dispatch = useDispatch();
    const { isLoading, isSuccess, isError, errors } = useSelector(
        (state) => state.designers
    );
    const { states } = useSelector((state) => state.AllStates);

    // State Designers Counts Of Create
    const licenseObj = {
        state_id: "",
        license_number: "",
        holder_name: "",
    };
    const [DesignerLicensesFormQuantity, setDesignerLicensesFormQuantity] =
        useState([licenseObj]);

    const handelAddNewState = () => {
        let data = DesignerLicensesFormQuantity;
        data = [...DesignerLicensesFormQuantity, licenseObj];
        setDesignerLicensesFormQuantity(data);
    };

    const handelFormChange = (e, index) => {
        let data = [...DesignerLicensesFormQuantity];
        data[index][e.target.name] = e.target.value;
        setDesignerLicensesFormQuantity(data);
    };

    const handelDeleteForm = (e, index) => {
        let data = [...DesignerLicensesFormQuantity];
        data.splice(index, 1);
        setDesignerLicensesFormQuantity(data);
    };
    const handelResetData = () => {};

    const AllStates = states?.data?.states;

    // get all states
    useEffect(() => {
        const getStates = async () => {
            await dispatch(getAllState());
            await dispatch(resetState());
        };
        getStates();
    }, [dispatch]);

    const formik = useFormik({
        initialValues: {
            name: "",
            email: "",
            phone: "",
            plan_price: "",
            structure_calculation_price: "",
            licenses: [],
        },
        // validationSchema: validationSchema,
        onSubmit: async (values) => {
            await dispatch(
                CreateNewDesigner({
                    ...values,
                    licenses: DesignerLicensesFormQuantity,
                })
            );
            await handelResetData();
            // await dispatch(designersReset());
        },
    });

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            }
            const reset = async () => {
                await dispatch(designersReset());
            };
            reset();
        }
        if (isSuccess) {
            toast.success("Designer created successfully");
            formik.values.name = "";
            formik.values.email = "";
            formik.values.phone = "";
            formik.values.plan_price = "";
            formik.values.structure_calculation_price = "";
            setDesignerLicensesFormQuantity([licenseObj]);
            const reset = async () => {
                await dispatch(designersReset());
            };
            reset();
        }
    }, [dispatch, errors, formik.values, isError, isSuccess, licenseObj]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <FormContainer>
                    <FormHeading> Add New Designer </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="name"
                                    required
                                    name="name"
                                    label="Name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.name &&
                                        Boolean(formik.errors.name)
                                    }
                                    helperText={
                                        formik.touched.name &&
                                        formik.errors.name
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="email"
                                    required
                                    name="email"
                                    label="Email"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.email &&
                                        Boolean(formik.errors.email)
                                    }
                                    helperText={
                                        formik.touched.email &&
                                        formik.errors.email
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="phone"
                                    required
                                    name="phone"
                                    label="Phone"
                                    value={formik.values.phone}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.phone &&
                                        Boolean(formik.errors.phone)
                                    }
                                    helperText={
                                        formik.touched.phone &&
                                        formik.errors.phone
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="plan_price"
                                    name="plan_price"
                                    required
                                    label="Plan Price"
                                    value={formik.values.plan_price}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.plan_price &&
                                        Boolean(formik.errors.plan_price)
                                    }
                                    helperText={
                                        formik.touched.plan_price &&
                                        formik.errors.plan_price
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="structure_calculation_price"
                                    name="structure_calculation_price"
                                    required
                                    label="Structure Calculation Price"
                                    value={
                                        formik.values
                                            .structure_calculation_price
                                    }
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched
                                            .structure_calculation_price &&
                                        Boolean(
                                            formik.errors
                                                .structure_calculation_price
                                        )
                                    }
                                    helperText={
                                        formik.touched
                                            .structure_calculation_price &&
                                        formik.errors
                                            .structure_calculation_price
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={12}>
                                <FormHeading> Designer Licenses </FormHeading>
                                {DesignerLicensesFormQuantity.map(
                                    (state, index) => {
                                        return (
                                            <Card
                                                key={index}
                                                variant="outlined"
                                                mb={2}
                                                style={{ padding: "10px" }}
                                            >
                                                <Box>
                                                    <Grid
                                                        mt={2}
                                                        container
                                                        columns={12}
                                                        spacing={3}
                                                    >
                                                        <Grid
                                                            item
                                                            mb={1}
                                                            xs={12}
                                                            md={10}
                                                        >
                                                            <Grid
                                                                container
                                                                columns={12}
                                                                spacing={3}
                                                            >
                                                                <Grid
                                                                    item
                                                                    mb={1}
                                                                    xs={12}
                                                                    md={6}
                                                                >
                                                                    <TextField
                                                                        fullWidth
                                                                        id="license_number"
                                                                        name="license_number"
                                                                        type="license_number"
                                                                        label="License Number"
                                                                        value={
                                                                            state.license_number
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            handelFormChange(
                                                                                e,
                                                                                index
                                                                            )
                                                                        }
                                                                    />
                                                                </Grid>

                                                                <Grid
                                                                    item
                                                                    mb={1}
                                                                    xs={12}
                                                                    md={6}
                                                                >
                                                                    <TextField
                                                                        fullWidth
                                                                        id="holder_name"
                                                                        name="holder_name"
                                                                        type="holder_name"
                                                                        label="Holder Name"
                                                                        value={
                                                                            state.holder_name
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            handelFormChange(
                                                                                e,
                                                                                index
                                                                            )
                                                                        }
                                                                    />
                                                                </Grid>

                                                                <Grid
                                                                    item
                                                                    mb={1}
                                                                    xs={12}
                                                                    md={6}
                                                                >
                                                                    <FormControl
                                                                        fullWidth
                                                                        required={
                                                                            true
                                                                        }
                                                                    >
                                                                        <InputLabel id="demo-simple-select-label">
                                                                            State
                                                                        </InputLabel>
                                                                        <Select
                                                                            id="state_id"
                                                                            name="state_id"
                                                                            label="State"
                                                                            required
                                                                            value={
                                                                                state.state_id
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                handelFormChange(
                                                                                    e,
                                                                                    index
                                                                                )
                                                                            }
                                                                        >
                                                                            {AllStates?.map(
                                                                                (
                                                                                    key
                                                                                ) => (
                                                                                    <MenuItem
                                                                                        key={
                                                                                            key.id
                                                                                        }
                                                                                        value={
                                                                                            key.id
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            key.name
                                                                                        }
                                                                                    </MenuItem>
                                                                                )
                                                                            )}
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            mb={1}
                                                            xs={12}
                                                            md={2}
                                                            sx={{
                                                                alignItems:
                                                                    "center",
                                                            }}
                                                        >
                                                            <Button
                                                                variant="contained"
                                                                fullWidth
                                                                disableElevation
                                                                color="error"
                                                                sx={{
                                                                    alignItems:
                                                                        "center",
                                                                }}
                                                                onClick={(e) =>
                                                                    handelDeleteForm(
                                                                        e,
                                                                        index
                                                                    )
                                                                }
                                                            >
                                                                <Delete />
                                                                Delete
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </Card>
                                        );
                                    }
                                )}
                            </Grid>
                        </Grid>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1}>
                                <Button
                                    onClick={() => {
                                        handelAddNewState();
                                    }}
                                    variant="contained"
                                    color="success"
                                >
                                    <Add></Add>
                                    Add New Licenses
                                </Button>
                            </Grid>
                        </Grid>
                        <PrimaryButton fullWidth type="submit">
                            {isLoading ? "loading ... " : " Add New Designer"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
export default CreateDesigner;
